import React from "react";
import { Routes, Route } from "react-router-dom";
import GlobalStyle from "./constants/globalStyles";
import Inicio from "./pages/inicio";
import Pasos from "./pages/pasos";
import Contacto from "./pages/contacto";
import TerminosYCondiciones from "./pages/terminosycondiciones";
import Privacidad from "./pages/privacidad";
import Nosotros from "./pages/nosotros";
import MisionYVision from "./pages/misionyvision";
import FormaParte from "./pages/formaparte";
import Bicicleterias from "./pages/bicicleterias";
import Logo from "./pages/logo";
import Error from "./pages/error";
import Loading from "./pages/loading";

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Home */}
        <Route exact path="/" element={<Inicio />} />
        {/* Pasos */}
        <Route exact path="/pasos" element={<Pasos />} />
        {/* Contacto */}
        <Route exact path="/contacto" element={<Contacto />} />
        {/* Privacidad */}
        <Route
          exact
          path="/terminosycondiciones"
          element={<TerminosYCondiciones />}
        />
        {/* Privacidad */}
        <Route exact path="/privacidad" element={<Privacidad />} />
        {/* Sobre Nosotros */}
        <Route exact path="/nosotros" element={<Nosotros />} />
        {/* Misión y Visión */}
        <Route exact path="/misionyvision" element={<MisionYVision />} />
        {/* Contacto */}
        <Route exact path="/formaparte" element={<FormaParte />} />
        {/* Bicicleterias */}
        <Route exact path="/bicicleterias" element={<Bicicleterias />} />
        {/* Logo Bicicleteria */}
        <Route exact path="/logo" element={<Logo />} />
        {/* Error Page */}
        <Route path="/*" element={<Error />} />
        {/* Loading Test Page */}
        <Route path="/loading" element={<Loading />} />
      </Routes>
      <GlobalStyle></GlobalStyle>
    </div>
  );
}

export default App;
